import { useFrame, useThree } from "@react-three/fiber"
import { useEffect } from "react"
import * as THREE from 'three'


const Experience = () => {

    const { camera, gl } = useThree()

    useFrame(()=>{
        camera.updateProjectionMatrix()
        gl.shadowMap.enabled = true
        gl.shadowMap.type = THREE.PCFShadowMap
        gl.shadowMap.autoUpdate = true
        gl.toneMappingExposure = 0.4
    },[])

    return <>
        <directionalLight
        position={[-10, 5, -6]}
        castShadow
        color={'#4AA7C9'}
        intensity={0.9}/>
        <spotLight intensity={0.8} position={[1,10,-8]} color={'purple'}/>
        <ambientLight intensity={0.4} position={[0,2,0]} color='#335CC5' />
        <spotLight color={'#ffefef'} position={[-20,-5.5,15]} intensity={0.4}/>
        <spotLight color={'#460038'} position={[1,0,0]} intensity={2.5} angle={2}/>
        <rectAreaLight color={'#ffefef'} intensity={2} position={[1,-1.5,11.5]} rotation={[1,0,3]}/>
    </>
}

export default Experience